import {
  SECURITY_REQUEST,
  SECURITY_SUCCESS,
  SECURITY_FAILURE,
} from './SecurityActionType';

const initialState = {
  loading: true,
  logged: false,
  userInfo: {},
};

export default (state = initialState, action) => {
  const { type } = action;

  switch (type) {
    case SECURITY_REQUEST:
      return { ...state, loading: true };
    case SECURITY_SUCCESS: {
      const { userInfo } = action.payload;
      return { ...state, loading: false, logged: !!userInfo, userInfo };
    }
    case SECURITY_FAILURE:
      return { ...state, loading: false, logged: false };
    default:
      return state;
  }
};
